export default __webpack_public_path__ + "static/media/vpayLogo.91e11322.svg";